const appassets = {
  emptydata: '/images/empty_data.svg',
  messageReceivedAudio: '/audio/message_received.wav'
}

export default appassets
